import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User is logged out due to session expiration',
  name: 'logged_out_due_to_session_expiration',
  params: [
    {
      description: 'Duration period (in seconds)',
      name: 'session_duration_time',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
